import { Box, styled } from '@mui/material';

import { COLORS } from '../../../../../configs/colors';

export const SummaryContainer = styled(Box)`
  background-color: ${COLORS.White};
  margin: 8px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const SummaryHeader = styled(Box)`
  padding: 12px 16px;
  background-color: ${COLORS.NavyBlue};
  color: ${COLORS.White};
`;

export const SummaryTitle = styled(Box)`
  font-size: 14px;
  font-weight: 600;
`;

export const SummaryContent = styled(Box)`
  padding: 16px;
`;

export const InfoRow = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid ${COLORS.SubtleGrey};

  &:last-child {
    border-bottom: none;
  }
`;

export const InfoIcon = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: ${COLORS.NavyBlue};
  flex-shrink: 0;
`;

export const InfoContent = styled(Box)`
  flex: 1;
  min-width: 0;
`;

export const InfoLabel = styled(Box)`
  font-size: 11px;
  color: ${COLORS.Gray};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
`;

export const InfoValue = styled(Box)`
  font-size: 14px;
  color: ${COLORS.Black};
  word-break: break-word;
`;

export const LocationSection = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid ${COLORS.SubtleGrey};
`;

export const LocationName = styled(Box)`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.Black};
`;

export const LocationAddress = styled(Box)`
  font-size: 13px;
  color: ${COLORS.Gray};
  margin-top: 2px;
`;

export const PartFaultGrid = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid ${COLORS.SubtleGrey};
`;

export const GridCell = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const GridCellLabel = styled(Box)`
  font-size: 11px;
  color: ${COLORS.Gray};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

export const GridCellValue = styled(Box)`
  font-size: 14px;
  color: ${COLORS.Black};
  word-break: break-word;
`;

export const SLAContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid ${COLORS.SubtleGrey};

  &:last-child {
    border-bottom: none;
  }
`;

export const SLALabel = styled(Box)`
  font-size: 12px;
  color: ${COLORS.Gray};
`;

export const SLAValue = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isBreached',
})<{ isBreached: boolean }>`
  font-size: 12px;
  font-weight: 600;
  color: ${({ isBreached }) => (isBreached ? COLORS.SLABreached : COLORS.SLAComplete)};
`;

export const ContractValueWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ContractLogo = styled('img')`
  width: 24px;
  height: 24px;
  object-fit: contain;
  border-radius: 4px;
  flex-shrink: 0;
`;

export const PriorityBadge = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})<{ bgColor?: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${({ bgColor }) => bgColor || COLORS.MediumGrey};
  color: ${COLORS.White};
`;

export const BadgeRow = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid ${COLORS.SubtleGrey};
`;

export const InfoBadge = styled(Box)`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  background-color: ${COLORS.LightBlueBackground};
  color: ${COLORS.NavyBlue};
`;

export const TwoColumnGrid = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid ${COLORS.SubtleGrey};
`;

export const StatusChip = styled(Box)`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 5px 6px 5px 12px;
  border-radius: 20px;
  background: linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%);
  color: ${COLORS.White};
  cursor: pointer;
  transition: opacity 0.15s ease;
  -webkit-tap-highlight-color: transparent;

  &:active {
    opacity: 0.75;
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.White};
    outline-offset: 2px;
  }
`;

export const StatusChipLabel = styled('span')`
  font-weight: 600;
  font-size: 0.78rem;
  white-space: nowrap;
`;

export const StatusChipArrow = styled('span')`
  display: flex;
  align-items: center;
  opacity: 0.7;
`;
